module.exports = __webpack_public_path__ + "static/ucla-logo-5c3acefee76576e4ba249359e67444b1.png";